module.exports = "<!DOCTYPE html><html><head><meta charset=utf-8><title><%= gridId %></title><body><%= gridContent %>";